<!-- CmmQuestionnaireAnswers.vue -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { CoverMyMedsEpaQuestionResponse, CoverMyMedsEpaQuestionAnswerItem, CoverMyMedsEpaQuestionItem, CmmAnswerValue, CoverMyMedsQuestionType, prettyChoiceText } from '../../../../lib/Api/CoverMyMeds';
    import MessageText from '../../../../components/Messages/MessageText.vue';
    import {IconTypes, TextDisplayStyle} from '../../../../Enums/UiEnums'
    import Icon from '../../../../components/Icon.vue';
    import { prettyDate, prettyTime } from '../../../../lib/DateUtils';

    const props = defineProps<{
        questionSet: CoverMyMedsEpaQuestionResponse,
        answers?: CoverMyMedsEpaQuestionAnswerItem[]
    }>();

    function questionFromAnswer(questionId: string): CoverMyMedsEpaQuestionItem
    {
        const question = props.questionSet?.questionList.find(q => q.questionId === questionId);
        if (!question)
        {
            const errMsg = "questionFromAnswer unable to find question";
            alert(errMsg);
            throw Error(errMsg);
        }
        return question;
    }

    type QuestionAndAnswer = { answerInfo: CoverMyMedsEpaQuestionAnswerItem, question: CoverMyMedsEpaQuestionItem};

    const anwersWithQuestion = computed<QuestionAndAnswer[]>(() => {
            const value = props.answers?.map(ans => { 
                return {
                    answerInfo: ans, 
                    question: questionFromAnswer(ans.questionId)
                }
            }) ?? [];
            return value;
        });

    function answerText(answerValue: CmmAnswerValue, question: CoverMyMedsEpaQuestionItem): string | undefined
    {
        switch(question.questionType)
        {
            case CoverMyMedsQuestionType.FreeText:
            case CoverMyMedsQuestionType.Numeric:
            return answerValue.answerValue;

            case CoverMyMedsQuestionType.MultiSelect:
            case CoverMyMedsQuestionType.SingleSelect:
            const choiceItem = props.questionSet.choiceList?.find(choice => choice.questionId == question.questionId && choice.choiceId == answerValue.answerValue);
            return prettyChoiceText(choiceItem);

            case CoverMyMedsQuestionType.Date:
            return prettyDate(answerValue.answerValue);

            case CoverMyMedsQuestionType.DateTime:
            return `${prettyDate(answerValue.answerValue)}, ${prettyTime(answerValue.answerValue)}`;

            default:
                alert("Unexpected question type: " + question.questionType);
                return;
        }
    }

</script>

<template>
    <div v-for="item in anwersWithQuestion" :key="item.answerInfo.questionId">
        <Icon :icon="IconTypes.Comment" title="Question" />
        {{ item.question.questionText }}
        <div class="ms-3" v-if="item.answerInfo">
            <div v-for="ans in item.answerInfo.answerValues">
                <i class="fa fa-comment fa-flip-horizontal text-info"></i>
                {{ answerText(ans, item.question) }}

                <div v-if="ans.additionalText" class="ms-1">
                    <MessageText :displayStyle="TextDisplayStyle.Muted">
                        Additional Text: 
                    </MessageText>
                    {{ ans.additionalText }}
                </div>

                <div v-if="item.answerInfo.attachmentId">
                    <Icon :icon="IconTypes.Attach" />
                    {{ item.answerInfo.attachmentId.name }}
                </div>
            </div>
        </div>
        <hr/>
    </div>
</template>